module.exports = __webpack_public_path__ + "static/media/record-complete-notification-icon.f6ae1070.png";